export interface LoggingContext {
  tags?: { [key: string]: any };
  contexts?: { [key: string]: any };
  level?: 'debug' | 'info' | 'warn' | 'error';
}

export interface SharedLogging {
  logDebug: (message: string, additionalContext?: LoggingContext) => void;
  logInfo: (message: string, additionalContext?: LoggingContext) => void;
  logWarn: (message: string, additionalContext?: LoggingContext) => void;
  logException: (error: Error, additionalContext?: LoggingContext) => void;
}

// Console logger for when no adapter is provided 
export const consoleLogger: SharedLogging = {
  logDebug: (message: string, additionalContext?: LoggingContext) => {
    console.debug(`[DEBUG] ${message}`, additionalContext || '');
  },
  logInfo: (message: string, additionalContext?: LoggingContext) => {
    console.info(`[INFO] ${message}`, additionalContext || '');
  },
  logWarn: (message: string, additionalContext?: LoggingContext) => {
    console.warn(`[WARN] ${message}`, additionalContext || '');
  },
  logException: (error: Error, additionalContext?: LoggingContext) => {
    console.error(`[ERROR] ${error.message}`, error, additionalContext || '');
  }
};